import { produce } from "immer";
import React, { useContext, useEffect } from "react";

import QuestionContext from "../QuestionContext";

import { styles } from "./common/image-map/Hotspot";
import ImageMap from "./common/image-map/ImageMap";
import Prompt from "./shared/Prompt";

const GraphicOrder = (props) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      let rsp = [];
      if (props?.data?.scoring?.order) {
        rsp = props?.data?.scoring?.order;
      }

      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: {
            order: rsp,
          },
        },
      });
    }
  }, [player.revealKey]);

  let spots = produce(props?.data?.content?.spots || [], (draft) => {
    draft = draft.map((s, idx) => {
      s.props = {};

      let rsp = player?.response?.[props.data.id]?.order;
      if (rsp && rsp.includes(s.id)) {
        let idxScoring;
        let iof = rsp.indexOf(s.id);
        s.props = { ...styles.selected };

        if (player.scoreResponses) {
          s.props = { ...styles.incorrect };

          if (props?.data?.scoring) {
            idxScoring = props.data?.scoring.order.indexOf(s.id);
            if (idxScoring !== -1 && iof === idxScoring) {
              s.props = { ...styles.correct };
            }
          }
        }

        // set label on the hotspot
        s.props.label = `${iof + 1}`;
      } else {
        s.props = styles.normal;
      }
    });
  });

  const handleSpotClick = (spot) => {
    let response = produce(player?.response?.[props.data.id] || {}, (draft) => {
      if (!draft.order) {
        draft.order = [];
      }
      if (player.scoreResponses) {
        draft.order = [];
      }

      if (!draft.order.includes(spot.id)) {
        draft.order.push(spot.id);
      } else {
        let iof = draft.order.indexOf(spot.id);
        draft.order.splice(iof, 1);
      }
    });

    dispatchPlayer({
      type: "RESPONSE",
      data: {
        id: props.data.id,
        response,
      },
    });
  };

  return (
    <div className="item-player-element item-player-stem item-player-stem-graphic-associate">
      <Prompt data={props.data.content.prompt} />
      {props.data.content.image && (
        <ImageMap
          image={props.data.content.image}
          map={{
            areas: spots,
          }}
          onSpotClick={handleSpotClick}
        />
      )}
    </div>
  );
};
export default GraphicOrder;
